<template>
    <div class="mb-5">
        <WorkflowNotification
            v-for="workflow in workflows"
            :key="workflow.WorklowPK"
            :workflow="workflow"
            :tenancy-pk="workflow.RelatedToFK"
            type="Property"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import WorkflowNotification from './WorkflowNotification';

export default {
    components: {
        WorkflowNotification,
    },

    data() {
        return {
            workflows: [],
        }
    },

    computed: {
        ...mapState('portfolioProperty', [
            'tenancies',
        ]),

        hasTenancies() {
            return (this.tenancies && this.tenancies.Rows && this.tenancies.Rows.length);
        },
    },

    async mounted() {
        await this.getTenancies();

        if(this.hasTenancies) {
            await this.getWorkflows();
        }
    },

    methods: {
        async getTenancies() {
            await this.$store.dispatch('portfolioProperty/getTenancies', this.$route.params.id);
        },

        getWorkflows() {
            for (const tenancy of this.tenancies.Rows) {
               return axios.get(`/api/contacts/portfolio/tenancies/${tenancy.TenancyPK}/workflows`)
                .then((response) => {
                    this.workflows.push(...response.data.data);
                });
            }
        },
    },
};
</script>
